'use client';

import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { CustomAnchor } from "../../quarks/CustomAnchor/CustomAnchor.js";
import { useId } from "../../utils/hooks/useId.js";
import { getRestProps } from "./utils/getRestProps.js";
import { getItemProps } from "./utils/getItemProps.js";
import { getButtonProps } from "./utils/getButtonProps.js";
import { getA11yTriggerProps } from "./utils/getA11yTriggerProps.js";
import { MenuItemContent } from "./MenuItem.Content.js";
const textDecorationNoneStyle = { textDecoration: "none" };
function MenuItemAsAnchorComponent(props, ref) {
  const { href, target, active } = props;
  const id = useId();
  return /* @__PURE__ */ jsx("li", { ...getItemProps(props), children: /* @__PURE__ */ jsx(
    CustomAnchor,
    {
      ...getRestProps(props),
      ...getButtonProps(props),
      ...getA11yTriggerProps(id, props),
      "aria-current": active ? "page" : void 0,
      href,
      ref,
      style: textDecorationNoneStyle,
      target,
      children: /* @__PURE__ */ jsx(MenuItemContent, { ...props, id })
    }
  ) });
}
const MenuItemAsAnchor = forwardRef(MenuItemAsAnchorComponent);
export {
  MenuItemAsAnchor
};
